import { FC } from 'react';
import { isMobile } from 'react-device-detect';
import Linkify from 'linkify-react';
import styled from 'styled-components';
import reactStringReplace from 'react-string-replace';

type MessageProps = {
    text: string;
    usersMap: string[];
    isChatHost?: boolean;
    imageMap: Array<Record<string, string>>;
};

const CustomEmoji = styled.img`
    ${isMobile
        ? `
            width: 2.188rem;
            height: 2.188rem;
            margin-bottom: -0.438rem;
        `
        : `
            width: 1.625rem;
            height: 1.625rem;
            margin-bottom: -0.375rem;
        `}
`;

const Mentions = styled.span`
    color: ${({ theme }) => theme.chatMain.color.mentions};
`;

const Link = styled.div`
    a {
        text-decoration: none;
        color: #007bff;
    }
`;

export const Message: FC<MessageProps> = ({
    text,
    imageMap,
    usersMap,
    isChatHost,
}) => {
    const escapeRegex = (value: string) =>
        value.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');

    const replaceEmojis = (value: string) => {
        const withMentions = reactStringReplace(value, /@(\w+)/g, (match) => {
            if (usersMap.includes(match)) {
                return <Mentions>@{match}</Mentions>;
            }

            return <span>@{match}</span>;
        });

        if (imageMap.length === 0) {
            return withMentions;
        }

        const emojiLookup = new Map(
            imageMap.map((emoji) => [emoji.keyCode.toLowerCase(), emoji.image])
        );

        const emojiRegex = new RegExp(
            `(${imageMap
                .map((emoji) => emoji.keyCode)
                .sort((a, b) => b.length - a.length)
                .map(escapeRegex)
                .join('|')})`,
            'gi'
        );

        return reactStringReplace(withMentions, emojiRegex, (match, i) => {
            const image = emojiLookup.get(match.toLowerCase());
            if (!image) {
                return match;
            }

            return (
                <CustomEmoji key={`${match}-${i}`} src={image} alt={match} />
            );
        });
    };

    return isChatHost ? (
        <Linkify as={Link} options={{ target: '_blank' }}>
            {replaceEmojis(text)}
        </Linkify>
    ) : (
        <div>{replaceEmojis(text)}</div>
    );
};
